import { useDataFormStore } from "@/stores/form";

export default {
  props: {
    ruleFormRef: Object,
  },

  setup() {
    const dataForm = useDataFormStore();

    const optionsWhoPays = [
      {
        value: "Sender",
        label: "Отправитель",
      },
      {
        value: "Consignee",
        label: "Получатель",
      },
      {
        value: "Customer",
        label: "Третье лицо",
      },
    ];
    const optionsTypeOfPayment = [
      {
        value: "Cash",
        label: "Наличные",
      },
      {
        value: "CashlessPayments",
        label: "Расчётный счёт юр.лица",
      },
    ];
    const counterparties = {
      sender: {
        value: "",
        arrayOfPayments: [],
      },
      consignee: {
        value: "",
        arrayOfPayments: [],
      },
      customer: {
        value: "",
        arrayOfPayments: [],
      },
    };
    const nameWhoPays = {
      delivery: {
        who: "whoPaysForCargoDelivery",
        typePayment: "typeOfPaymentForCargoDelivery",
        counterpartie: "",
      },
      transportation: {
        who: "whoPaysForCargoTransportation",
        typePayment: "typeOfPaymentForCargoTransportation",
        counterpartie: "",
      },
      extrapacking: {
        who: "whoPaysForCargoExtraPacking",
        typePayment: "typeOfPaymentForCargoExtraPacking",
        counterpartie: "",
      },
    };

    const checkNameWho = (value) => value.slice(15).toLowerCase();

    const checkNameTypePayment = (value) => value.slice(21).toLowerCase();

    const convertToEnglish = (value) => value === "Отправитель" ? "Sender" : value === "Получатель" ? "Consignee" : value === "Третье лицо" ? "Customer" : "";

    const findField = (obj, value) => obj[Object.keys(obj).filter(item => item.indexOf(value) >= 0 )];

    return {
      dataForm,
      optionsWhoPays,
      optionsTypeOfPayment,
      counterparties,
      nameWhoPays,
      checkNameTypePayment,

      checkingPresenceThirdPerson: function (label) {
        return dataForm.thirdPerson.cargoTransportationCustomer !== 'Третье лицо' && label === 'Третье лицо'
      },

      handlerChangeWhoPays: function (stateName) {
        const forWhat = checkNameWho(stateName);
        const nameTypePayment = nameWhoPays[forWhat].typePayment;
        let counterpartie = convertToEnglish(nameWhoPays[forWhat].counterpartie).toLowerCase();

        if (counterpartie) {
          counterparties[counterpartie].arrayOfPayments.splice(
            counterparties[counterpartie].arrayOfPayments.indexOf(
              nameTypePayment
            ),
            1
          );
        }

        counterpartie = convertToEnglish(dataForm.payment[stateName]).toLowerCase();
        nameWhoPays[forWhat].counterpartie = dataForm.payment[stateName]
        counterparties[counterpartie].arrayOfPayments.push(nameTypePayment);
        if(!counterparties[counterpartie].value.length) {
          dataForm[counterpartie][findField(dataForm[counterpartie], 'Type')]
          counterparties[counterpartie].value = findField(dataForm[counterpartie], 'Type') ? "Расчётный счёт юр.лица" : "Наличные"
        }
        dataForm.payment[nameTypePayment] = counterparties[counterpartie].value;
        
      },

      handlerChangeTypeOfPayment: function (stateName) {
        const forWhat = checkNameTypePayment(stateName);
        const counterpartie = convertToEnglish(nameWhoPays[forWhat].counterpartie).toLowerCase();
        let typeName
  
        if (counterpartie) {
          counterparties[counterpartie].value = dataForm.payment[stateName];
          for (typeName of counterparties[counterpartie].arrayOfPayments) {
            dataForm.payment[typeName] = counterparties[counterpartie].value
          }
        }
      },
    };
  },
};
